import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function ContactPage() {
  const navigate = useNavigate();

  // ✅ Lock body scroll only on this page (app-shell handles scrolling)
  useEffect(() => {
    document.body.classList.add("app-lock");
    return () => document.body.classList.remove("app-lock");
  }, []);

  return (
    <div className="app-shell bg-[#020617] text-slate-200 font-['Inter']">
      {/* ✅ HEADER (fixed/sticky area) */}
      <header className="app-header bg-[#020617]/90 backdrop-blur border-b border-white/10 px-6 py-4">
        <div className="max-w-3xl mx-auto flex items-start justify-between gap-4">
          <div>
            <h1 className="text-3xl font-bold text-white mb-2 leading-tight">
              Get in <br />
              <span className="text-[#eb6fbd]">Touch</span>
            </h1>
            <div className="h-1 w-24 bg-[#eb6fbd] rounded" />
            <p className="mt-4 text-slate-300 leading-relaxed">
              We’re here to help. Reach out using the details below and we’ll get back to you.
            </p>
          </div>

          <button
            onClick={() => navigate("/dashboard")}
            className="shrink-0 bg-[#eb6fbd] hover:bg-[#d946ef] text-white px-5 py-2 rounded-full font-bold
                       shadow-lg shadow-[#eb6fbd]/20 transition-colors"
          >
            Dashboard
          </button>
        </div>
      </header>

      {/* ✅ BODY (scrolls) */}
      <main className="app-body px-6 py-6">
        <div className="max-w-3xl mx-auto space-y-8">
          {/* CONTENT */}
          <section className="space-y-6 text-slate-300 leading-relaxed">
            <InfoCard title="Company" icon="🏢">
              Reignite.Spirit Ltd
            </InfoCard>

            <InfoCard title="Address" icon="📍">
              <div className="space-y-1">
                <div>2902, D21, 29, Sky Tower, Shams Abu Dhabi,</div>
                <div>Abu Dhabi, Al Reem Island, United Arab Emirates</div>
              </div>
            </InfoCard>

            <InfoCard title="Website" icon="🌐">
              <a
                href="https://www.reignitespirit.com"
                target="_blank"
                rel="noreferrer"
                className="text-[#eb6fbd] hover:text-[#d946ef] underline underline-offset-4"
              >
                www.reignitespirit.com
              </a>
            </InfoCard>

            <InfoCard title="Email" icon="✉️">
              <a
                href="mailto:info@reignitespirit.com"
                className="text-[#eb6fbd] hover:text-[#d946ef] underline underline-offset-4"
              >
                info@reignitespirit.com
              </a>
            </InfoCard>
          </section>

          {/* CTA */}
          <div className="pt-2 flex flex-col sm:flex-row gap-4 justify-center">
            <button
              onClick={() => navigate("/dashboard")}
              className="bg-[#eb6fbd] hover:bg-[#d946ef] text-white px-10 py-3 rounded-md font-bold
                         shadow-lg shadow-[#eb6fbd]/20 transition-colors"
            >
              Back to Dashboard →
            </button>

            <a
              href="mailto:info@reignitespirit.com"
              className="text-center bg-white/5 hover:bg-white/10 text-white px-10 py-3 rounded-md font-bold
                         border border-white/10 transition-colors"
            >
              Email Us
            </a>
          </div>

          {/* Optional spacing at bottom for iOS safe-area */}
          <div className="h-6" />
        </div>
      </main>
    </div>
  );
}

function InfoCard({ title, icon, children }) {
  return (
    <div className="p-5 rounded-xl bg-white/5 border border-white/10 shadow-lg shadow-black/20">
      <h3 className="text-xl font-bold text-white mb-2 flex items-center gap-2">
        <span className="text-[#eb6fbd]">{icon}</span>
        {title}
      </h3>
      <div className="text-slate-300">{children}</div>
    </div>
  );
}